import React, { useState, useEffect } from 'react';
import axios from 'axios';
import apiConfig from '../api/apiConfig';

const CorsTest = () => {
  const [testResult, setTestResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const runTest = async () => {
    setLoading(true);
    setError(null);
      // Log the full URL being requested for debugging
    const testUrl = `${apiConfig.baseURL}/cors-test`;
    const pingUrl = `${apiConfig.baseURL}/ping`;
    
    console.log('Backend base URL:', apiConfig.baseURL);
    console.log('Attempting CORS test with URL:', testUrl);
    console.log('Attempting ping with URL:', pingUrl);
    console.log('Using headers:', apiConfig.headers);
    
    try {
      // Try the ping endpoint first to check basic connectivity
      console.log('Testing ping endpoint...');
      try {
        const pingResponse = await axios.get(pingUrl, apiConfig);
        console.log('Ping response:', pingResponse.data);
      } catch (pingError) {
        console.error('Ping test failed:', pingError);
      }
      
      // Now try the CORS test endpoint
      console.log('Testing CORS endpoint...');
      const response = await axios.get(testUrl, apiConfig);
      console.log('CORS test response:', response.data);
      setTestResult(response.data);
    } catch (error) {
      console.error('CORS test error:', error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error('Error data:', error.response.data);
        console.error('Error status:', error.response.status);
        console.error('Error headers:', error.response.headers);
        setError(`${error.toString()}\nStatus: ${error.response.status}\nData: ${JSON.stringify(error.response.data)}`);      } else if (error.request) {
        // The request was made but no response was received
        console.error('No response received. Request:', error.request);
        setError(`${error.toString()}\nNo response received from server`);
        
        // Try with a basic fetch as a last resort
        console.log('Trying with basic fetch API as fallback...');
        try {
          fetch(pingUrl, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          })
          .then(response => response.text())
          .then(data => {
            console.log('Fetch API ping response:', data);
          })
          .catch(fetchError => {
            console.error('Fetch API ping error:', fetchError);
          });
        } catch (fetchError) {
          console.error('Fetch API setup error:', fetchError);
        }
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error setting up request:', error.message);
        setError(error.toString());
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Test on component mount
    runTest();
  }, []);

  return (
    <div style={{ margin: '20px', padding: '20px', border: '1px solid #ccc' }}>
      <h2>CORS Test</h2>
      <p>Testing connection to: {apiConfig.baseURL}</p>
      
      {loading && <p>Testing connection...</p>}
      
      {error && (
        <div style={{ color: 'red', margin: '10px 0' }}>
          <h3>Error:</h3>
          <pre>{error}</pre>
        </div>
      )}
      
      {testResult && (
        <div style={{ color: 'green', margin: '10px 0' }}>
          <h3>Success:</h3>
          <pre>{JSON.stringify(testResult, null, 2)}</pre>
        </div>
      )}
      
      <button onClick={runTest} disabled={loading}>
        {loading ? 'Testing...' : 'Test Again'}
      </button>
    </div>
  );
};

export default CorsTest;
